import { useEffect } from "react"
import { CCard, CCardBody, CCardFooter, CCardImage, CCardText, CCardTitle } from "@coreui/react-pro"

function Icon({ name }) {
  const paths = {
    saved: <path d="M6 3h12v19l-6-4-6 4z" />,
    pin: <><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 0 1 14 0z" /><circle cx="12" cy="10" r="2" /></>,
    arrow: <path d="M4 12h16m-6-6 6 6-6 6" />
  }

  return (
    <svg className="g-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  )
}

export default function GuideCard({ entry, labels, savedPage = false }) {
  // After mounting, the guide Stimulus controller owns bookmark state and visibility.
  return (
    <CCard className="place-card" role="article" data-slug={entry.slug}
      data-guide-target={savedPage ? "savedCard" : undefined} hidden={savedPage}>
      <div className="place-image" style={{ aspectRatio: `${entry.image.width} / ${entry.image.height}` }}>
        <a href={entry.url} tabIndex={-1} aria-hidden="true">
          <CCardImage orientation="top" src={entry.image.src} alt="" loading="lazy"
            width={entry.image.width} height={entry.image.height} />
        </a>
        <span className="image-tag">{entry.category}</span>
        <button type="button" className="bookmark-button" data-guide-target="bookmark"
          data-slug={entry.slug} data-action="guide#toggle" aria-label={labels.save} aria-pressed="false">
          <Icon name="saved" />
        </button>
      </div>
      <CCardBody className="place-body">
        <CCardText className="place-location"><Icon name="pin" />{entry.location}</CCardText>
        <CCardTitle as="h3"><a href={entry.url}>{entry.title}</a></CCardTitle>
        <CCardText className="place-summary">{entry.summary}</CCardText>
        <CCardFooter className="place-footer">
          <span>{labels.editorsPick}</span>
          <a href={entry.url} aria-label={`${labels.readGuide}: ${entry.title}`}><Icon name="arrow" /></a>
        </CCardFooter>
      </CCardBody>
    </CCard>
  )
}

export function GuideCards({ cards, labels, savedPage, onReady }) {
  useEffect(onReady, [onReady])

  return cards.map(entry => <GuideCard key={entry.slug} entry={entry} labels={labels} savedPage={savedPage} />)
}
